import { asInstant, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.processor.ContentProcessingError
 *
 * @typedef {object} ContentProcessingErrorData
 * @property {string|null} message
 * @property {number|string|null} timestamp
 */

/**
 * @param {object} raw
 * @returns {ContentProcessingErrorData}
 */
export function fromContentProcessingErrorData(raw) {
  const source = requireObject(raw, 'ContentProcessingError');
  return {
    message: optionalString(source.message),
    timestamp: asInstant(source.timestamp),
  };
}
